module.exports = __webpack_public_path__ + "img/home-mission-d-01.jpg?fc043cbda8c5ce762803ef621a2eff20";